module.exports = __webpack_public_path__ + "static/media/plantbasednuggets-explore-more.a22dbaac.jpg";